import { atom } from 'recoil'

export default atom({
  key: 'day',
  default: 1,
})
